import * as React from 'react';
import { Dispatch } from 'redux';

import * as EntityNormalizers from '../normalizers/entityNormalizers';

import { BaseApiRequest } from './baseApiRequest';

export abstract class BaseApiDeleteRequest<
  ResponseType,
  ReturnType extends EntityNormalizers.NormalizedEntity<any>
> extends BaseApiRequest<ResponseType, ReturnType> {
  protected constructor(component: React.Component, dispatch: Dispatch, shouldDispatchError?: boolean) {
    super(component, dispatch, shouldDispatchError);
    this.method = 'DELETE';
  }
}
